import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getGrowthOverview, listGrowthAccounts } from '../../lib/adminApi';
import type { GrowthAccountsFilters } from '../../types/admin';
import { adminKeys } from './adminQueryKeys';

const GROWTH_STALE_MS = 5 * 60 * 1000;

export function useGrowthOverview(weeks: number) {
  return useQuery({
    queryKey: adminKeys.growth.overview(weeks),
    queryFn: () => getGrowthOverview(weeks),
    placeholderData: keepPreviousData,
    staleTime: GROWTH_STALE_MS,
  });
}

export function useGrowthAccounts(filters: GrowthAccountsFilters) {
  return useQuery({
    queryKey: adminKeys.growth.accounts(filters as Record<string, unknown>),
    queryFn: () => listGrowthAccounts(filters),
    placeholderData: keepPreviousData,
    staleTime: GROWTH_STALE_MS,
  });
}
